/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Termsofuse_Title2Inputs */

const he_seo_termsofuse_title2 = /** @type {(inputs: Seo_Termsofuse_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תנאי שימוש - Pricedrop`)
};

const en_seo_termsofuse_title2 = /** @type {(inputs: Seo_Termsofuse_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Use - Pricedrop`)
};

/**
* | output |
* | --- |
* | "Terms of Use - Pricedrop" |
*
* @param {Seo_Termsofuse_Title2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const seo_termsofuse_title2 = /** @type {((inputs?: Seo_Termsofuse_Title2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Termsofuse_Title2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_termsofuse_title2(inputs)
	return en_seo_termsofuse_title2(inputs)
});
export { seo_termsofuse_title2 as "seo_termsOfUse_title" }